// extracted by mini-css-extract-plugin
export default {"card":"AAOBu","wrapper":"F48gZ","content":"i_5Cb","title":"j0gv8","text":"lTgaX","error-msg":"tdChF"};